import React from 'react';
import PropTypes from 'prop-types';

const Ratings = props => {
	const { ratings, ratingScale, prefs } = props;
	if (!ratings) {
		return null;
	}
	const { overallRatingPadding, overallRatingBgColor } = prefs;
	return (
		<div className="kbb-ratings ml-auto">
			<div
				className={`${overallRatingBgColor} border ddc-font-size-small text-center ${overallRatingPadding}`.trim()}
			>
				<span className="text-muted">Overall</span>
				<strong className="ddc-font-size-xxlarge d-block font-weight-bold">
					{ratings[0].value}
				</strong>
				<span className="text-muted">Out of {ratingScale}</span>
			</div>
		</div>
	);
};

Ratings.propTypes = {
	ratings: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired
		})
	).isRequired,
	ratingScale: PropTypes.number.isRequired,
	prefs: PropTypes.shape({
		overallRatingPadding: PropTypes.string,
		overallRatingBgColor: PropTypes.string
	}).isRequired
};

export default Ratings;



// WEBPACK FOOTER //
// ./src/components/Ratings.jsx